export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./deviceCheck.vue?vue&type=template&id=4aa197c0&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./src/views/classroom1/components/deviceCheck.vue?vue&type=template&id=4aa197c0&scoped=true&
// module id = null
// module chunks = 